import { render } from "./RegisterAccess.vue?vue&type=template&id=ff7b32b6"
import script from "./RegisterAccess.vue?vue&type=script&lang=js"
export * from "./RegisterAccess.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__